import React from "react"
import { useTranslation } from "react-i18next"

import { ConfirmationOverlay } from "shared/ui/confirmation-overlay/ConfirmationOverlay"

export interface DeleteFavoritesOverlayViewModel {
  autoFocus?: boolean
  confirm: () => void
  closeOverlay: () => void
}

export const DeleteFavoritesOverlayView = React.memo(
  ({ autoFocus, confirm, closeOverlay }: DeleteFavoritesOverlayViewModel) => {
    const { t } = useTranslation()
    return (
      <ConfirmationOverlay.Root
        id="delete-favorites-overlay"
        isDanger
        autoFocus={autoFocus}
      >
        <ConfirmationOverlay.Header>
          <ConfirmationOverlay.Title>
            {t("Favorites.Actions.Delete")}
          </ConfirmationOverlay.Title>
        </ConfirmationOverlay.Header>
        <ConfirmationOverlay.Message>
          {t("Favorites.DeleteConfirmation")}
        </ConfirmationOverlay.Message>
        <ConfirmationOverlay.Actions>
          <ConfirmationOverlay.Cancel onClick={closeOverlay} />
          <ConfirmationOverlay.Submit onClick={confirm}>
            {t("General.Delete")}
          </ConfirmationOverlay.Submit>
        </ConfirmationOverlay.Actions>
      </ConfirmationOverlay.Root>
    )
  }
)
